


































































import { Component, Vue } from "vue-property-decorator";
import { ServicesObjectDto } from "@/api/appService";
import api from "@/api";
import ProvinceCityAreaView, {
  ProvinceCityAreaTownDto,
} from "@/components/CustomForm/FormDetail/components/ProvinceCityAreaView.vue";
import ProvinceCityAreaContent from "@/components/CustomForm/FormDetail/components/ProvinceCityAreaContent.vue";

@Component({
  name: "serviceObjectDetail",
  components: { ProvinceCityAreaView, ProvinceCityAreaContent },
  filters: {},
})
export default class ServiceObjectDetail extends Vue {
  editServiceObjectId?: number;
  detail: ServicesObjectDto = {};
  loading = true;

  foundationArea: ProvinceCityAreaTownDto = {
    provinceId: 0,
    cityId: 0,
    areaId: 0,
  };

  created() {
    if (this.$route.params.id) {
      this.editServiceObjectId = Number(this.$route.params.id);
      this.fetchDetail();
    }
  }

  // 获取详情
  async fetchDetail() {
    await api.serviceObject
      .get({ id: this.editServiceObjectId })
      .then((res) => {
        this.loading = false;
        this.detail = { ...res };
        this.foundationArea = {
          provinceId: res!.provinceId ?? 0,
          cityId: res!.cityId ?? 0,
          areaId: res!.areaId ?? 0,
        };
        console.log(res);
      });
    console.log(this.detail);
  }

  // 返回
  private cancel() {
    this.$router.back();
  }
}
